import React from 'react'
import AdminTCList from '../../features/admin/AdminTCList'

const AdminTCListPage = () => {
  return <AdminTCList/>
}

export default AdminTCListPage